import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Virginia Eggs · Fresh from the Farm</p>
        <h1>Discover the Taste of Freshness</h1>
        <p className="lede">
          At Virginia Eggs, we bring you the highest quality eggs, sourced directly from local farms. Experience the difference that fresh, farm-raised eggs can make in your cooking and baking.
        </p>
        <div className="cta-row">
          <a href="/products" target="_self">
            Shop Now
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Farm Fresh Quality</h2>
          <p>
            Our eggs are collected daily from local farms, ensuring you receive the freshest product possible.
          </p>
        </article>
        <article>
          <h2>Healthy and Nutritious</h2>
          <p>
            Packed with essential nutrients, our eggs are a wholesome choice for you and your family.
          </p>
        </article>
        <article>
          <h2>Support Local Farmers</h2>
          <p>
            By choosing Virginia Eggs, you’re supporting local agriculture and sustainable farming practices.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;